// extracted by mini-css-extract-plugin
export var avatarContainer = "_5e-0";
export var avatarTypingWave = "_5e-i";
export var gray = "_5e-f";
export var green = "_5e-c";
export var icon = "_5e-9";
export var image = "_5e-1";
export var lg = "_5e-6";
export var md = "_5e-5";
export var presenceDot = "_5e-b";
export var red = "_5e-d";
export var sm = "_5e-4";
export var status = "_5e-a";
export var typingDot = "_5e-h";
export var typingPill = "_5e-g";
export var xl = "_5e-7";
export var xs = "_5e-3";
export var xxl = "_5e-8";
export var xxs = "_5e-2";
export var yellow = "_5e-e";